<template>
	<div>
		<case-form :schema="schemaFamily" class="mt6" />
		<div class="fs4 fw7 lh125 mt6">
			If answered “Yes” to the above question, provide details:
		</div>
		<j-accordion
			v-for="i in 3"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">Details</span>
				{{ i }}
			</div>
			<div slot="body" class="pr6 pl6 pt6 pb2 bg5">
				<case-form :schema="schemaFamilyList(i)" :isBoxed="false" />
			</div>
		</j-accordion>

		<div class="fs4 fw7 lh125 mt6 mb6">
			Please provide current age or age at death and cause of death of remaining
			family members not recorded above:
		</div>

		<div class="fs4 fw7 lh125 mb2">Mother</div>
		<case-form :schema="schemaMotherDetails" class="mb6" />

		<div class="fs4 fw7 lh125 mb2">Father</div>
		<case-form :schema="schemaFatherDetails" class="mb6" />

		<div class="fs4 fw7 lh125 mb2">Brothers</div>
		<j-accordion
			v-for="i in 2"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">Details</span>
				{{ i }}
			</div>
			<div slot="body" class="pr6 pl6 pt6 pb2 bg5">
				<case-form :schema="schemaBrotherDetails(i)" :isBoxed="false" />
			</div>
		</j-accordion>

		<div class="fs4 fw7 lh125 mt6 mb2">Sisters</div>
		<j-accordion
			v-for="i in 2"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">Details</span>
				{{ i }}
			</div>
			<div slot="body" class="pr6 pl6 pt6 pb2 bg5">
				<case-form :schema="schemaSisterDetails(i)" :isBoxed="false" />
			</div>
		</j-accordion>
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
import JAccordion from "@/components/JAccordion/"

export default {
	components: {
		CaseForm,
		JAccordion
	},

	computed: {
		schemaFamily() {
			return [
				{
					label: `Have any of your biological parents, brothers or sisters ever been diagnosed with heart disease, stroke or transient
ischemic attack (TIA), cancer, diabetes, Parkinson’s disease, Huntington’s disease, polycystic kidney disease (PKD),
Alzheimer’s disease, or any other hereditary disease or disorder?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasFamilyBeenDiagnosed`,
					props: {
						suggest: {
							typeIncludes: `hasFamilyBeenDiagnosed`
						},
						createOptions: {
							type: `hasFamilyBeenDiagnosed`,
							dataType: "boolean"
						}
					}
				}
			]
		},

		schemaMotherDetails() {
			return [
				{
					label: `Current Age`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0motherCurrentAge`,
					props: {
						suggest: {
							typeIncludes: `motherCurrentAge`
						},
						createOptions: {
							type: `motherCurrentAge`,
							dataType: "string"
						}
					}
				},
				{
					label: `or Age at Death and Cause of Death`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0motherAgeAndCauseOfDeath`,
					props: {
						suggest: {
							typeIncludes: `motherAgeAndCauseOfDeath`
						},
						createOptions: {
							type: `motherAgeAndCauseOfDeath`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaFatherDetails() {
			return [
				{
					label: `Current Age`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0fatherCurrentAge`,
					props: {
						suggest: {
							typeIncludes: `fatherCurrentAge`
						},
						createOptions: {
							type: `fatherCurrentAge`,
							dataType: "string"
						}
					}
				},
				{
					label: `or Age at Death and Cause of Death`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0fatherAgeAndCauseOfDeath`,
					props: {
						suggest: {
							typeIncludes: `fatherAgeAndCauseOfDeath`
						},
						createOptions: {
							type: `fatherAgeAndCauseOfDeath`,
							dataType: "string"
						}
					}
				}
			]
		}
	},

	methods: {
		schemaFamilyList(i) {
			return [
				{
					label: `Your relationship to family member`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0diagnosedFamilyRelationship${i}`,
					props: {
						suggest: {
							typeIncludes: `diagnosedFamilyRelationship${i}`
						},
						createOptions: {
							type: `diagnosedFamilyRelationship${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Condition`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0diagnosedFamilyCondition${i}`,
					props: {
						suggest: {
							typeIncludes: `diagnosedFamilyCondition${i}`
						},
						createOptions: {
							type: `diagnosedFamilyCondition${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Age at onset`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0diagnosedFamilyAgeAtOnset${i}`,
					props: {
						suggest: {
							typeIncludes: `diagnosedFamilyAgeAtOnset${i}`
						},
						createOptions: {
							type: `diagnosedFamilyAgeAtOnset${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Age if living`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0diagnosedFamilyAgeIfLiving${i}`,
					props: {
						suggest: {
							typeIncludes: `diagnosedFamilyAgeIfLiving${i}`
						},
						createOptions: {
							type: `diagnosedFamilyAgeIfLiving${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Age at death`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0diagnosedFamilyAgeAtDeath${i}`,
					props: {
						suggest: {
							typeIncludes: `diagnosedFamilyAgeAtDeath${i}`
						},
						createOptions: {
							type: `diagnosedFamilyAgeAtDeath${i}`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaBrotherDetails(i) {
			return [
				{
					label: `Current Age`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0brotherCurrentAge${i}`,
					props: {
						suggest: {
							typeIncludes: `brotherCurrentAge${i}`
						},
						createOptions: {
							type: `brotherCurrentAge${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `or Age at Death and Cause of Death`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0brotherAgeAndCauseOfDeath${i}`,
					props: {
						suggest: {
							typeIncludes: `brotherAgeAndCauseOfDeath${i}`
						},
						createOptions: {
							type: `brotherAgeAndCauseOfDeath${i}`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaSisterDetails(i) {
			return [
				{
					label: `Current Age`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0sisterCurrentAge${i}`,
					props: {
						suggest: {
							typeIncludes: `sisterCurrentAge${i}`
						},
						createOptions: {
							type: `sisterCurrentAge${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `or Age at Death and Cause of Death`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0sisterAgeAndCauseOfDeath${i}`,
					props: {
						suggest: {
							typeIncludes: `sisterAgeAndCauseOfDeath${i}`
						},
						createOptions: {
							type: `sisterAgeAndCauseOfDeath${i}`,
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
